// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9_-f-","colMin":"styles_colMin__qs3g6"};